import { VaporAlert, VaporAlertProps } from "../VaporAlert";
export const NotificationOverflow = VaporAlert;
export interface NotificationOverflowProps extends VaporAlertProps {}
